export default __webpack_public_path__ + "static/media/1.244d60b1.png";